<template>
  <div>
    <el-row type="flex" class="info-boxes" :gutter="32">
      <el-col class="box" :xs="24" :md="12">
        <elsa-section :title="$t('classes.classes_details.overview_section.title')">
          <template v-slot:body>
            <el-row :gutter="30" type="flex" align="middle" class="learners">
              <el-col :xs="24" :sm="12" class="students user-info">
                <icon-info-box icon="students-class" :value="numberOfStudents" :label="$t($i18nLabelsHelper(organizationType, 'students'))" :showListText="numberOfStudents > 0 ? $t('classes.classes_details.overview_section.view_list') : ''" :showListAction="openListStudents" />
                <invite-learner-modal v-show="canInviteLearner" @on-invited="$emit('goToTabIndex', 2)"/>
              </el-col>
              <el-col :xs="24" :sm="12" v-show="hasPendingUsers" class="students user-info">
                <icon-info-box v-if="numberOfPending > 0" icon="students-class" :value="numberOfPending" :label="$t('common.pending_invites')" :showListText="$t('classes.classes_details.overview_section.view_list')" :showListAction="handleShowPendingInvites" />
              </el-col>
            </el-row>
            <el-row type="flex" :gutter="35" class="licences">
              <!-- <el-col :xs="24" :sm="12">
                <icon-info-box
                  icon="pro-licences-enable"
                  value="80"
                  label="Students with Pro License"
                />
              </el-col>
              <el-col :xs="24" :sm="12">
                <icon-info-box
                  icon="pro-licences-disable"
                  value="5"
                  label="Students without Pro License"
                  inviteText="Assign Pro Licenses"
                />
              </el-col> -->
              <el-col :xs="24" :sm="12" v-if="currentClass.start_date" class="status-report">
                <class-progress :classData="currentClass" />
              </el-col>
              <el-col v-if="currentClass.owner" :xs="24" :sm="12" class="teacher user-info">
                <initial-avatar v-bind="$attrs" :size="70" :avatarUrl="currentClass.owner.photo_url" :userObject="currentClass.owner" />
                <div class="user">
                  <div class="info">
                    <span class="label">
                      {{ $t($i18nLabelsHelper(organizationType, 'teacher')) }}
                    </span>
                    <span> {{ teacherName }}</span>
                    <span class="email">
                      {{ currentClass.owner.email }}
                    </span>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" v-else class="students user-info">
                <icon-info-box icon="students-class" value="1" :label="$t($i18nLabelsHelper(organizationType, 'pending_invites_teacher'))" :showListText="$t('classes.classes_details.overview_section.view_list')" :showListAction="handleShowPendingInviteTeacher" />
              </el-col>
              <el-col :xs="24" :sm="12" v-if="canEditClass" class="status-report">
                <icon-info-box v-if="assessmentTestScore" icon="average-score" :value="assessmentTestScore | toPercentage" :label="$t('classes.classes_details.overview_section.assessment_test_results')" />
              </el-col>
            </el-row>
          </template>
        </elsa-section>
      </el-col>
      <el-col class="box" :xs="24" :md="12">
        <elsa-section :title="$t('classes.classes_details.overview_section.goals')">
          <template v-slot:body>
            <el-row type="flex" :gutter="15">
              <slot v-if="practiceMinutesPerDay && practiceDaysPerWeek">
                <el-col v-if="practiceMinutesPerDay" :xs="24" :sm="12">
                  <icon-info-box icon="goals-minutes-day" :value="practiceMinutesPerDay" :label="$t('classes.classes_details.overview_section.minutes_per_day')" />
                </el-col>
                <el-col v-if="practiceDaysPerWeek" :xs="24" :sm="12">
                  <icon-info-box icon="goals-days-practice" :value="practiceDaysPerWeek" :label="$t('classes.classes_details.overview_section.days_practice_per_week')" />
                </el-col>
                <el-col v-if="canEditClass && testBeforeClassStats" :xs="24" :sm="12" class="status-report">
                  <icon-info-box icon="average-score" :value="testBeforeClassStats" :label="$t('classes.classes_details.overview_section.test_before_class_stats')" />
                </el-col>
              </slot>
              <slot v-else>
                <el-col :span="24">
                  <h4>
                    {{ $t('classes.classes_details.overview_section.no_goals_set') }}
                  </h4>
                  <chip class="elsa-icon-plus" @click.native="setGoals">
                    {{ $t('classes.classes_details.overview_section.set_goals') }}
                  </chip>
                </el-col>
              </slot>
            </el-row>
          </template>
        </elsa-section>
      </el-col>
    </el-row>

    <!-- <el-row type="flex" :gutter="35" class="info-boxes">
      <el-col :span="24" v-if="currentClass.start_date" class="status-report">
        <class-progress
          :classData="currentClass"
        />
      </el-col>
    </el-row> -->

    <charts-fragment
      v-if="canEditClass"
      :totalStudents="numberOfStudents"
      :weeklyActiveStudents="weeklyActiveStudents"
      :activeStudents="activeStudents"
      :avgPracticeTime="avgPracticeTime"
      :endDate="endDate"
      :eps="eps"
      :overview="overviewData"
      :sumActiveStudents="sumActiveStudents"
      :prevOverview="prevOverviewData"
      :organizationType="organizationType"
      :startDate="startDate"
      :lessonsTotalTimePracticed="lessonsTotalTimePracticed"
      :lessonsTimePracticed="lessonsTimePracticed"
      :studySetTimePracticed="studySetTimePracticed"
      :scope="scope"
      :showStudentsImprovement="true"
      :isLoadingImproChart="isLoadingImproChart"
      :studentsImprovement="studentsImprovement"
      @updatedDate="updatedDate"
      @updateScope="updateScope"
      :timelineLabel="timelineLabel"
      :avg-elsa-score="avgElsaScore"
      :distributionEps="distributionEps"
      :distributionIelts="distributionIelts"
      :pentagon="pentagon"
      :highestAverageScoreSkills="highestAverageScoreSkills"
      :lowestAverageScoreSkills="lowestAverageScoreSkills"
      :loadingAverageScoreSkills="loadingAverageScoreSkills"
      :lessonsPracticedMinuteGoal="practiceMinutesPerDay"
      :totalLessonsPracticedMinuteGoalInDuration="totalLessonsPracticedMinuteGoalInDuration"
      :hasAdditionScore="hasAdditionScore"
    />

    <pending-invite-users :title="$t('common.pending_invites')" :dialogVisible="showPendingUsersModal" @closed="showPendingUsersModal = false" :pendingInviteUsers="pendingInviteUsersPage" :currentPage.sync="pendingUsersCurrentPage" :total="numberOfPending" pendingInviteTypeScope="class" />
    <pending-invite-teacher :title="$t($i18nLabelsHelper(organizationType, 'pending_invites_teacher'))" :pendingInviteTeacher="currentClass.pending_teacher" :dialogVisible="showPendingTeacherModal" @closed="showPendingTeacherModal = false" />
  </div>
</template>

<script>
import { format, formatDistance, eachDayOfInterval, startOfMonth, toDate } from 'date-fns'
import ElsaSection from '@/components/common/ElsaSection'
import IconInfoBox from '@/components/common/IconInfoBox'
import ClassProgress from '@/components/common/ClassProgress'
import ChartsFragment from '@/components/common/charts/ChartsFragment'
import Chip from '@/components/common/Chip'
import PendingInviteUsers from '@/components/modals/PendingInviteUsers'
import PendingInviteTeacher from '@/components/modals/classes/PendingInviteTeacher'
import { propOr, pathOr, map, compose, pathEq, unless, isNil, lt } from 'ramda'
import { mapActions, mapState, mapGetters } from 'vuex'
import percentage from '@/components/common/mixins/percentage'
import showNoReportDataWarning from '@/components/common/mixins/noReportData'
import InitialAvatar from '@/components/common/InitialAvatar'
import { warningMessage, successMessage } from '../../../utils/messages'
import { isSessionExpireError } from '@/utils/sessionExpireErr'
import InviteLearnerModal from '@/components/modals/organizations/InviteLearnersModal.vue'

export default {
  mixins: [percentage, showNoReportDataWarning],
  components: {
    ElsaSection,
    IconInfoBox,
    ClassProgress,
    ChartsFragment,
    Chip,
    InitialAvatar,
    PendingInviteUsers,
    PendingInviteTeacher,
    InviteLearnerModal
  },
  data() {
    return {
      activeName: 'team',
      showPendingUsersModal: false,
      showPendingTeacherModal: false,
      pendingUsersCurrentPage: 1
    }
  },
  props: ['currentClass', 'organizationType', 'startDate', 'endDate', 'scope', 'timelineLabel'],
  computed: {
    numberOfStudents: pathOr(0, ['currentClass', 'users_count']),
    numberOfPending: pathOr(0, ['currentClass', 'pending_invitations']),
    hasPendingUsers: compose(lt(0), propOr(0, 'numberOfPending')),
    teacherName() {
      const firstName = propOr('', ['owner', 'first_name'])(this.currentClass)
      const lastName = propOr('', ['owner', 'last_name'])(this.currentClass)

      return `${firstName} ${lastName}`
    },
    practiceMinutesPerDay() {
      return pathOr(null, ['assignment', 'practice_minutes_per_day'])(this.currentClass)
    },
    practiceDaysPerWeek() {
      return pathOr(null, ['assignment', 'practice_days_per_week'])(this.currentClass)
    },
    testBeforeClassStats() {
      return pathOr(null, ['assignment', 'test_before_class_stats'])(this.currentClass)
    },
    dateLabels() {
      const start = this.startDate
      const end = this.endDate
      const labels = compose(
        map((date) => format(date, 'MMM d')),
        eachDayOfInterval
      )({ start, end })

      return labels
    },
    isOwner() {
      const userId = this.currentUserId
      return pathEq(['currentClass', 'owner', 'id'], userId)(this)
    },
    canEditClass() {
      return this.userIsAdmin || this.userIsAssociateAdmin || (this.userIsTeacher && this.isOwner)
    },
    canInviteLearner() {
      return this.userIsAdmin || this.userIsAssociateAdmin
    },
    assessmentTestScore: compose(unless(isNil, Math.ceil), pathOr(null, ['assessmentTest', 'score'])),
    ...mapState('classes', [
      'lessonsTotalTimePracticed',
      'lessonsTimePracticed',
      'studySetTimePracticed',
      'avgPracticeTime',
      'avgProgress',
      'activeStudents',
      'eps',
      'overviewData',
      'prevOverviewData',
      'weeklyActiveStudents',
      'assessmentTest',
      'studentsImprovement',
      'isLoadingImproChart',
      'avgElsaScore',
      'distributionEps',
      'distributionIelts',
      'pentagon',
      'highestAverageScoreSkills',
      'lowestAverageScoreSkills',
      'loadingAverageScoreSkills',
      'sumActiveStudents',
    ]),
    ...mapGetters({
      currentUserId: 'user/getUserId',
      userIsTeacher: 'organization/isOrganizationTeacher',
      userIsAdmin: 'organization/isOrganizationAdmin',
      userIsAssociateAdmin: 'organization/isOrganizationAssociateAdmin',
      pendingInviteUsersPage: 'classes/pendingInviteUsersPage',
      latestAssessments: 'classes/getLatestAssessments',
    }),
    startDateAndendDateAndscope() {
      return `${this.startDate}|${this.endDate}${this.scope}`
    },
    totalLessonsPracticedMinuteGoalInDuration() {
      let dayCount = 1
      if (this.scope === 'weekly') {
        dayCount = this.practiceDaysPerWeek
      } else if (this.scope === 'monthly') {
        dayCount = (this.practiceDaysPerWeek * (30 / 7))
      }
      return Number((this.practiceMinutesPerDay * this.numberOfStudents * dayCount).toFixed(0))
    },
    hasAdditionScore() {
      return this.getUserAdditionalScore && this.getUserAdditionalScore.hasOwnProperty("sgd")
    },
    getUserAdditionalScore() {
      if(this.latestAssessments.length > 0) {
        for(var i = 0; i < this.latestAssessments.length; i++ ) {
          if (this.latestAssessments[i].last_assessment.additional_score)
          return JSON.parse(this.latestAssessments[i].last_assessment.additional_score)
        }
        return {}
      } else {
        return {}
      }
    },
  },
  methods: {
    getAllChartDataPeriod(options) {
      return this.getChartDataPeriod(options).catch((err) => {
        if(!isSessionExpireError(err))
          this.showNoReportDataWarning();
      })
    },
    getAllChartDataNoPeriod(options) {
      return this.getChartDataNoPeriod(options).catch((err) => {
        if(!isSessionExpireError(err))
          this.showNoReportDataWarning();
      })
    },
    setGoals() {
      this.$emit('setGoals')
    },
    updatedDate(dateObject) {
      return this.$emit('updatedDate', dateObject)
    },
    updateScope(newScope) {
      return this.$emit('updateScope', newScope)
    },
    formatDate(date) {
      return format(new Date(date), 'dd MMM yyyy')
    },
    distanceBetweenDate() {
      const startDate = this.currentClass.status === 'active' ? new Date() : new Date(this.currentClass.end_date)
      const endDate = this.currentClass.status === 'active' ? new Date(this.currentClass.end_date) : new Date(this.currentClass.start_date)
      const prefix = this.currentClass.status === 'active' ? this.$t('classes.classes_details.left') : this.$t('classes.classes_details.to_go')
      return formatDistance(startDate, endDate) + prefix
    },
    handleShowPendingInvites() {
      this.showPendingUsersModal = true
      this.getPendingInviteUsers()
    },
    handleShowPendingInviteTeacher() {
      this.showPendingTeacherModal = true
    },
    openListStudents() {
      this.$emit('showStudents')
    },
    ...mapActions('classes', ['getChartDataPeriod', 'getChartDataNoPeriod', 'getLessonsOverview', 'getPendingInviteUsers', 'resetEpsChart', 'getLatestAssessments']),
  },
  async mounted() {
    if (this.currentClass.id) {
      try {
        await this.getAllChartDataNoPeriod();
        await this.getAllChartDataPeriod({
          from: this.startDate,
          to: this.endDate,
          scope: this.scope
        });
      } catch (error) {
        return warningMessage(this.$t('common.generic_error_message'))
      }
    }
  },
  watch: {
    startDateAndendDateAndscope: {
      async handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          await this.getAllChartDataPeriod({
            from: this.startDate,
            to: this.endDate,
            scope: this.scope
          })
          await this.getLatestAssessments({from: this.startDate, to: this.endDate, page: 1 });
        }
      }
    },
    async '$store.state.classes.currentClass.id'() {
      this.getLatestAssessments({from: this.startDate, to: this.endDate, page: 1 });
      await this.getAllChartDataNoPeriod();
      return this.getAllChartDataPeriod({
        from: this.startDate,
        to: this.endDate,
        scope: this.scope
      })
    },
    pendingUsersCurrentPage(page) {
      return this.getPendingInviteUsers({ page })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.licences {
  margin-top: 32px;
}
.learners {
  display: flex;
  align-items: flex-start !important;
  justify-content: space-between;
}
.elsa-section {
  padding-bottom: 32px;
  height: 100%;
  &::v-deep .section-body {
    margin-top: 32px;
  }
}

.elsa-chip {
  background-color: white;
  margin-top: 10px;
}

.spacer {
  margin-top: 32px;
}

.info-boxes {
  .box {
    margin-top: 32px;
    overflow: hidden;
    & > div {
      margin-top: 32px;
    }
    .status-report {
      margin-top: 28px;
    }
    .user-info {
      display: flex;
      align-items: center;
      row-gap: 10px;
      column-gap: 10px;
      flex-wrap: wrap;
      flex-grow: 1;
      // justify-content: space-between;
      img.avatar {
        width: 64px;
        height: 64px;
        border-radius: 50%;
      }
      .user {
        display: flex;
        flex-direction: column;
        margin-left: -12px;
        text-transform: capitalize;
        color: $darker-blue;
        width: 100%;
      }
    }
    .students {
      .counter {
        > span {
          font-weight: bold;
          font-size: 28px;
          letter-spacing: 0.03em;
          mix-blend-mode: normal;
        }
        p {
          margin: 0;
          font-size: 16px;
        }
        span.link {
          font-weight: 600;
          font-size: 12px;
          text-decoration-line: underline;
          color: $blue;
          mix-blend-mode: normal;
          cursor: pointer;
        }
      }
    }
    .teacher {
      padding-right: 0px !important;
      .user {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .info {
          display: flex;
          flex-direction: column;
        }
      }
      span {
        font-weight: 600;
        font-size: 16px;
        text-transform: capitalize;
        color: $purple;
        &.label {
          font-size: 14px;
          text-transform: capitalize;
          color: $dark-blue-2;
          margin-bottom: 5px;
        }
        &.email {
          font-weight: normal;
          text-transform: lowercase;
          color: $darker-blue;
        }
      }
    }
  }
}

::v-deep .progress-wrapper .el-progress {
  width: 100%;
  margin-right: 0;
}
.el-row {
  flex-wrap: wrap;
  .el-col:not(:first-of-type) {
    @media only screen and (max-width: 768px) {
      margin-top: 30px;
    }
  }
}

.pie-charts-wrapper::v-deep .section-body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

h4 {
  font-weight: bold;
}

::v-deep .icon-info-box .info span.label {
  font-size: 10px;
}
::v-deep .invite-single-learner {
  height: 42px;
  font-size: 16px;
}
</style>
